import React, { useEffect, useRef, useState } from 'react';

import Swal from 'sweetalert2';

import utils from '../../Helpers/FunctionsHelpers';
import IssueClosureModalDocExpireModal from '../Custom/IssueClosureModalDocExpireModal';
import IssuesClosureModal from '../Custom/IssuesClosureModal';
import MassTreatmentModal from '../Custom/MassTreatmentModal';
import { SystemTypeIdDocsExpiration } from '../Enums/MaintenanceTypeIds';
import NCModal from '../Main/NCModal';
import Table from '../Table/Table';

import { getGestaoIssuesList, getWarningList } from '../Api/Api';

export default function Urgents() {
  const $ = require('jquery');
  const [criticals, setCriticals] = useState([]);
  const [systemMaintenance, setSystemMaintenance] = useState([]);
  const [warningList, setWarningList] = useState([]);
  const [show, setShow] = useState(false);
  const [showClosureModal, setShowClosureModal] = useState(false);
  const [showClosureDocExpireModal, setShowClosureDocExpireModal] =
    useState(false);
  const [client_id, setClientId] = useState();
  const [selectedNCs, setSelectedNCs] = useState([]);
  const selectedNCsRef = useRef([]);
  const [showMassTreatmentModal, setShowMassTreatmentModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const intervalMinutes = 1;

  const columns = [
    {
      title: 'NC',
      data: 'system_maintenance_id',
      className: 'text-center align-middle',
    },
    {
      title: 'Unidade',
      data: 'info_name',
      className: 'align-middle',
    },
    {
      title: 'Sistema',
      data: 'system_type_name',
      className: 'text-center align-middle',
    },
    {
      title: 'Problema',
      data: 'system_maintenance_text',
      className: 'align-middle',
      width: '40%',
    },
    {
      title: 'Prioridade',
      data: 'maintenance_type_priority',
      className: 'text-center align-middle',
      createdCell: function (cell, cellData) {
        if (cellData) {
          if (cellData === 'Crítico') {
            $(cell).addClass('criticals');
          } else if (cellData === 'Urgente') {
            $(cell).addClass('urgente');
          }
        }
      },
    },
    {
      title: 'Data de criação',
      data: 'system_maintenance_created',
      className: 'text-center align-middle',
      render: (data, x, row) => {
        return `${data}`;
      },
    },
    {
      title: 'Prazo sugerido',
      data: 'system_maintenance_expiration',
      className: 'text-center align-middle',
      render: (data, x, row) => {
        return `${data}`;
      },
    },
    {
      title: 'Prazo documental',
      data: 'document_expiration',
      className: 'text-center align-middle',
      render: function (data) {
        if (data) {
          return data;
        } else {
          return '-';
        }
      },
    },
    {
      title: 'Responsabilidade',
      data: 'is_responsable_s2u',
      className: 'text-center align-middle',
      width: '10%',
      render: (data, x, row) => {
        let badgeColor = 'secondary';
        let badgeTitle = 'Cliente';

        if (data === '1') {
          badgeColor = 'danger';
          badgeTitle = 'SAFETY2U';
        }

        return `<span class="badge rounded-pill bg-${badgeColor} pr-7" title=${badgeTitle}>&nbsp;</span>`;
      },
    },
    {
      title: 'Ações',
      data: null,
      className: 'text-center align-middle',
    },
  ];

  const actionButtons = (row) => {
    const anySelected = selectedNCs.length > 0;
    return (
      <>
        <button
          className={`btn btn-sm btn-primary m-2 treating ${anySelected ? 'disabled' : ''}`}
          onClick={(e) => {
            if (anySelected) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            handleShow(row);
          }}
          disabled={anySelected}
          title={
            anySelected
              ? 'Desmarque os itens selecionados para habilitar este botão'
              : 'Tratativas'
          }
        >
          Tratativas
        </button>
        <button
          type="btn"
          className="btn btn-sm btn-danger px-3"
          onClick={() => handleEnd(row)}
        >
          Encerrar
        </button>
      </>
    );
  };

  const handleClosureModal = async () => {
    setShowClosureModal(true);
  };

  const handleCloseClosureModal = () => {
    getOrganizationClients();
    setShowClosureModal(false);
  };

  const handleModalDocExpire = async () => {
    setShowClosureDocExpireModal(true);
  };

  const handleCloseModalDocExpire = () => {
    getOrganizationClients();
    setShowClosureDocExpireModal(false);
  };

  const handleEnd = async (row) => {
    await setSystemMaintenance(row);
    setClientId(row.client_id);
    if (SystemTypeIdDocsExpiration.includes(row.maintenance_type_id)) {
      handleModalDocExpire();
    } else {
      handleClosureModal();
    }
  };

  const handleShow = async (row) => {
    setSystemMaintenance([]);
    setShow(true);
    setSystemMaintenance(row);
    const rst = await getWarningList(row.system_maintenance_id);
    if (rst) {
      setWarningList(rst.data);
    }
  };

  const handleClose = () => {
    getOrganizationClients();
    setShow(false);
  };

  const handleSelectionChange = (selectedIds) => {
    const selectedData = criticals.filter((nc) =>
      selectedIds.includes(nc.system_maintenance_id)
    );

    const simplifiedData = selectedData.map((nc) => ({
      system_maintenance_id: nc.system_maintenance_id,
      system_type_id: nc.system_type_id,
    }));

    setSelectedNCs(simplifiedData);
  };

  const handleShowMassTreatmentModal = (selectedIds) => {
    let dataToUse;

    if (selectedIds && selectedIds.length > 0) {
      dataToUse = criticals
        .filter((nc) => selectedIds.includes(nc.system_maintenance_id))
        .map(({ system_maintenance_id, system_type_id }) => ({
          system_maintenance_id,
          system_type_id,
        }));
    }

    if (dataToUse.length > 0) {
      const hasControlePrazos = dataToUse.some(
        (nc) => nc.system_type_id === '15'
      );
      const hasOtherSystems = dataToUse.some(
        (nc) => nc.system_type_id !== '15'
      );

      if (hasControlePrazos && hasOtherSystems) {
        Swal.fire(
          'OPS!',
          "Não é possível realizar a tratativa em massa enquanto houverem NCs do tipo 'Controle de Prazos' misturados com outros tipos de sistemas na seleção",
          'error'
        );
        return;
      }

      setShowMassTreatmentModal(true);
    }
  };

  const handleCloseMassTreatmentModal = () => {
    setShowMassTreatmentModal(false);
  };

  const handleMassTreatmentSuccess = () => {
    setSelectedNCs([]);
    setIsLoading(true);
    setCriticals([]);
    getOrganizationClients();
  };

  const getOrganizationClients = async () => {
    setCriticals([]);
    setIsLoading(true);
    var data = {
      prior: 4,
    };
    const res = await getGestaoIssuesList(data);
    if (res.data) {
      setCriticals(res.data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    selectedNCsRef.current = selectedNCs;
  }, [selectedNCs]);

  useEffect(() => {
    utils.manageSidebar('close');
    getOrganizationClients();

    const interval = setInterval(
      () => {
        if (selectedNCsRef.current.length > 0) {
          return;
        }
        if (!show) {
          getOrganizationClients();
        }
      },
      1000 * 60 * intervalMinutes
    );
    return () => clearInterval(interval);
  }, [show]);

  return (
    <>
      <main id="main" className="main">
        <section className="section">
          <div className="col-12">
            <div className="card">
              <div className="card-header">Urgentes/Críticos (diário)</div>
              <div className="card-body scrollBase">
                {isLoading ? (
                  <div className="text-center mt-5">
                    <div
                      className="spinner-border text-primary"
                      role="status"
                    />
                    <p className="mt-2">Carregando dados...</p>
                  </div>
                ) : (
                  <Table
                    data={criticals}
                    columns={columns}
                    btnColumn={9}
                    actBtns={actionButtons}
                    keepState={true}
                    selectable={true}
                    useCheckboxes={true}
                    onSelectionChange={handleSelectionChange}
                    selectedRows={selectedNCs}
                    onBulkAction={handleShowMassTreatmentModal}
                  />
                )}
              </div>
            </div>
          </div>
        </section>
        <IssuesClosureModal
          isOpen={showClosureModal}
          systemMaintenance={systemMaintenance}
          onClose={handleCloseClosureModal}
          client_id={client_id}
        />
        <IssueClosureModalDocExpireModal
          show={showClosureDocExpireModal}
          close={handleCloseModalDocExpire}
          system_maintenance_id={systemMaintenance?.system_maintenance_id}
          system_maintenance_created={
            systemMaintenance?.system_maintenance_created
          }
          client_id={client_id}
        />
        <NCModal
          show={show}
          handleClose={handleClose}
          userId={sessionStorage.getItem('gestao_userId')}
          systemMaintenance={systemMaintenance}
          warningList={warningList}
          setShow={setShow}
        />
        <MassTreatmentModal
          show={showMassTreatmentModal}
          handleClose={handleCloseMassTreatmentModal}
          selectedNCs={selectedNCs}
          onSuccess={handleMassTreatmentSuccess}
        />
      </main>
    </>
  );
}
